import { Button } from "@mui/material";
import { useAuth } from "react-oidc-context";

function AuthInfo() {
	const auth = useAuth();

	if (auth?.isAuthenticated) {
		return '';
	} else {
		return (<Button id="sk-signin-button" onClick={() => auth.signinRedirect()}>Please sign in</Button>);
	}
}

export default AuthInfo;